/* src/app/hire-sidebar/hire-sidebar.component.scss */
.hire-sidebar {
  width: 64px;
  height: 100%;
  background-color: #0E626D;
  padding: 16px 17px;
  display: inline-flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 8;
  transition: width 0.5s;
}
.hire-sidebar button {
  outline: none;
  border: none;
  background-color: transparent;
  padding: 0;
  transition: width 0.5s;
}
.top-sidenav {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  gap: 40px;
  transition: width 0.5s;
}
.top-sidenav .top-logo {
  width: 30px;
  display: flex;
  overflow: hidden;
  transition: width 0.5s;
}
.top-sidenav .top-nav-menu {
  width: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
  gap: 12px;
  transition: width 0.5s;
  overflow: hidden;
}
.top-sidenav .top-nav-menu button {
  padding: 5px;
  border-radius: 4px;
  transition: width 0.5s;
  display: flex;
  overflow: hidden;
  gap: 16px;
  align-items: center;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.top-sidenav .top-nav-menu button span:nth-of-type(2) {
  width: 200px;
  display: none;
  flex-wrap: wrap;
}
.top-sidenav .top-nav-menu button.active {
  background-color: rgba(255, 255, 255, 0.4);
}
.bottom-sidenav {
  width: 100%;
  display: flex;
  gap: 12px;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  transition: width 0.5s;
  overflow: hidden;
}
.bottom-sidenav button {
  padding: 5px;
  border-radius: 4px;
  transition: width 0.5s;
  display: flex;
  overflow: hidden;
  gap: 16px;
  align-items: center;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottom-sidenav button span:nth-of-type(2) {
  width: 200px;
  display: none;
  flex-wrap: nowrap;
}
.bottom-sidenav button .needhelpbtn span:nth-of-type(2) {
  width: max-content;
  display: none;
  flex-wrap: nowrap;
}
.bottom-sidenav button.active {
  background-color: rgba(255, 255, 255, 0.4);
}
.bottom-sidenav .devider {
  display: block;
  height: 1px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.2);
}
.hire-sidebar:hover {
  width: 250px;
  align-items: start;
  transition: width 0.5s;
}
.hire-sidebar:hover .top-sidenav {
  width: 100%;
}
.hire-sidebar:hover .top-logo {
  width: 100%;
}
.hire-sidebar:hover .top-nav-menu {
  width: 100%;
  align-items: start;
  transition: width 0.8s;
}
.hire-sidebar:hover .top-nav-menu button {
  width: 100%;
  text-align: left;
  transition: width 0.5s;
}
.hire-sidebar:hover .top-nav-menu button:hover {
  background-color: rgba(255, 255, 255, 0.4);
}
.hire-sidebar:hover .top-nav-menu button span:nth-of-type(2) {
  display: flex;
}
.hire-sidebar:hover .bottom-sidenav {
  width: 100%;
  align-items: start;
  transition: width 0.8s;
  overflow: visible;
}
.hire-sidebar:hover .bottom-sidenav button {
  width: 100%;
  text-align: left;
  transition: width 0.5s;
}
.hire-sidebar:hover .bottom-sidenav button:hover:not(.notClickableBTN) {
  background-color: rgba(255, 255, 255, 0.4);
}
.hire-sidebar:hover .bottom-sidenav button span:nth-of-type(2) {
  display: flex;
}
.hire-sidebar:hover .bottom-sidenav button.notClickableBTN {
  cursor: default;
}
.hire-sidebar:hover .bottom-sidenav button.notClickableBTN:hover {
  background-color: none !important;
}
.hire-sidebar:hover .bottom-sidenav .needhelpbtn span:nth-of-type(2) {
  display: flex;
}
.needhelpbtn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.needhelpbtn span svg {
  transition: transform 0.4s ease-in;
  transform: rotate(0deg);
}
.dropend {
  width: 100%;
  position: relative;
}
.dropend button {
  width: 100%;
}
.dropend .dropdown-toggle::after {
  display: none;
}
.dropdown-menu.mymenu.show {
  position: absolute;
  inset: 0px auto auto 0px;
  margin: 0px;
  transform: translate(235px, 0px) !important;
  inset: auto auto 0px 0px !important;
  margin-left: 10px;
  width: 230px;
  min-height: 180px;
  max-height: 350px;
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  font-size: 12px;
  font-weight: 400;
  background-color: #0E626D;
}
.dropdown-menu.mymenu.show::before {
  content: "";
  display: block;
  width: 25px;
  height: 100vh;
  background-color: transparent;
  position: absolute;
  left: -25px;
  top: -25px;
}
.dropdown-menu.mymenu.show li {
  width: 100%;
}
.dropdown-menu.mymenu.show li a {
  width: 100%;
  display: flex;
  padding: 8px 10px;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
  text-decoration: none;
}
.dropdown-menu.mymenu.show button {
  padding: 8px;
  width: 100%;
}
.dropdown-menu.mymenu.show button span:nth-of-type(2) {
  width: 100%;
  display: none;
  flex-wrap: wrap;
}
.dropdown-menu.mymenu.show .notClickableBTN {
  width: 100%;
}
.dropdown-menu.mymenu.show .help-icon-down-angle svg {
  transition: transform 0.1s ease-in;
  transform: rotate(90deg);
}
.dropdown-menu.mymenu.show .bg-white-active {
  background-color: rgba(255, 255, 255, 0.4);
}
.dropdown-menu.mymenu.show .rotate.help-icon-down-angle svg {
  transition: transform 0.1s ease-in;
  transform: rotate(-90deg);
}
.dropdown-toggle .needhelpbtn span svg {
  transition: transform 0.1s ease-in;
  transform: rotate(180deg);
}
.dropdown-toggle.show .needhelpbtn span svg {
  transition: transform 0.1s ease-in;
  transform: rotate(0deg);
}
.list-inside-collapse ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  margin-bottom: 2px;
  margin-top: 2px;
}
.list-inside-collapse ul li {
  width: 100%;
}
.list-inside-collapse ul li a {
  width: auto !important;
  display: flex;
  padding: 9.65px 10px;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  color: #ffffff;
  font-size: 12px;
  font-weight: 400;
  text-decoration: none;
  margin-left: 30px;
  border-radius: 3px;
  transition: background-color 0.2s ease-in;
}
.list-inside-collapse ul li:hover a {
  background-color: rgba(255, 255, 255, 0.4);
}
/*# sourceMappingURL=hire-sidebar.component-XRCT2NB3.css.map */
